const $$splitComponentImporter = () => import('/app/src/routes/dashboard/supervisor/sessions.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { CircleNotch, User } from "@phosphor-icons/react";
export const Route = createFileRoute("/dashboard/supervisor/sessions")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface SupervisorSession {
  id?: string;
  scheduledAt: string;
  clientName: string;
  status: "scheduled" | "completed" | "cancelled" | "no_show";
  durationMinutes: number;
}
interface PaginatedSupervisorSessions {
  sessions: SupervisorSession[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}